import { getAssetConfig } from '~config/protocol';
import { AllVestaAssets } from '~config/types';

import { black, white, secondaryColors } from './colors';

export const defaultBorder = { border: `1px solid ${white['15%']}` };
export const secondaryBorder = { border: `1px solid ${secondaryColors[200]}` };
export const defaultBackground = { background: black['45%'], borderRadius: '8px' };

export const primaryBox = (user: boolean, asset: AllVestaAssets) => ({
  p: '32px',
  background: user ? getAssetConfig(asset).styles?.gradient ?? black['45%'] : black['45%'],
  borderRadius: '8px',
});

export const secondaryBox = {
  ...defaultBackground,
  px: '32px',
  py: '24px',
  borderRadius: '8px',
};

export const secondaryBoxPadding = {
  px: '32px',
  py: '24px',
};

export const secondaryBoxHoverable = {
  ...defaultBackground,
  px: '32px',
  py: '24px',
  border: '1px solid rgba(0, 0, 0, 1)',
  borderRadius: '8px',
  transition: 'border 0.15s ease-in',

  '&:hover': {
    border: '1px solid ' + secondaryColors[200],
  },
};

export const columnGap = (gap: number) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: `${gap}px`,
});

export const hideScrollbar = {
  overflowY: 'scroll',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
};

export const secondaryHoverBorder = {
  border: '1px solid transparent',
  '&:hover': {
    border: `1px solid ${secondaryColors[200]}`,
  },
};

export const maxWidth = '1086px';
